module.exports = __webpack_public_path__ + "img/img-a010c8e8.747a00ea.png";